import { render, staticRenderFns } from "./UpdateEventDialog.vue?vue&type=template&id=067f0d1a"
import script from "./UpdateEventDialog.vue?vue&type=script&lang=ts"
export * from "./UpdateEventDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports